import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RolPlataforma } from '../../core/models/novedades.models';
import { RoleContextService } from '../../core/services/role-context.service';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { BreadcrumbItem, Breadcrumbs } from '../../shared/components/breadcrumbs/breadcrumbs';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';
import { PrincipalDashboardPanel } from '../principal/components/principal-dashboard-panel/principal-dashboard-panel';
import { InicioConcursosPanel } from './components/inicio-concursos-panel/inicio-concursos-panel';

@Component({
  selector: 'app-inicio',
  imports: [
    CommonModule,
    FormsModule,
    SidebarMenu,
    PrincipalDashboardPanel,
    InicioConcursosPanel,
    AccessibilityToolbar,
    Breadcrumbs,
    UserSessionSummary,
  ],
  templateUrl: './inicio.html',
  styleUrl: './inicio.css',
})
export class Inicio implements OnInit {
  readonly breadcrumbs: BreadcrumbItem[] = [{ label: 'Inicio' }];
  rolSeleccionado: RolPlataforma = 'postulante';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly roleContext: RoleContextService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.rolSeleccionado = this.roleContext.resolveRole(params, this.rolSeleccionado);
    });
  }

  get mostrarConcursos(): boolean {
    return this.rolSeleccionado === 'administrador_anid';
  }
}
